import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AuthenticationGuard } from './authentication.guard';

@NgModule({
  imports: [CommonModule],
  providers: [AuthenticationGuard],
})
export class SharedAuthAuthenticationModule {}
